import * as React from 'react';
import * as _ from 'underscore';

import { IGlob } from '../../../../pdc-platform/src/ts/Glob';
import { IPopupOptions } from '../../../../pdc-platform/src/ts/actions/DialogActions';
import { ISuggestionValue } from './ListSelectItem';
import SuggestionListField, { GetValuesResult, IType, IUpdateStateHook } from '../SuggestionListField';
import { IValuesCollection } from '../../ts/appTheme';
import * as reactGlobalClick from '../../ts/reactGlobalClick';

export interface ISuggestionsDropdownOptions extends IPopupOptions {
    value: ISuggestionValue[];
    displayValues: ISuggestionValue[];
    allowNull: boolean;
    sortByDisplayValue: boolean;
    singleSelectMode: boolean;
    keySelect: boolean;
    listThreshold: number;
    placeholder: string;
    hideSearchField?: boolean;
    readOnly: boolean;
    hideSelectAllAndClear: boolean;
    defaultSearchString?: string;
    theme: IValuesCollection;
    notSetFocusOnClose?: boolean;
    minSelectedItemsCellWidth?: number;
    types?: IType[];
    allowAdding?: boolean;
    allowReordering?: boolean;
    usePlaceholderAsTitle?: boolean;

    updateStateHook?: IUpdateStateHook;
    getValues(): GetValuesResult;
    getDisplayValue(value: string): string;

    onChange(value: ISuggestionValue[]): void;
    onClose?(): void;
}

export function SuggestionsDropdown(props: {
    zIndex: number;
    options: ISuggestionsDropdownOptions;
    glob: IGlob;

    close(): void;
}) {
    const handleOnClose = React.useCallback(() => {
        if (props.options.onClose != null) {
            props.options.onClose();
        }

        props.close();
    }, [props.options.onClose, props.close]);

    reactGlobalClick.useGlobalClickHook(handleOnClose, 1);

    const handleOnContainerClick = React.useCallback((e) => {
        reactGlobalClick.cancel();

        e.stopPropagation();
        e.preventDefault();
    }, []);

    const options = props.options;

    return (
        <SuggestionListField
            popupMode={true}
            value={options.value}
            singleSelectMode={options.singleSelectMode}
            displayValues={options.displayValues}
            keySelect={options.keySelect}
            sortByDisplayValue={options.sortByDisplayValue}
            allowNull={options.allowNull}
            allowAdding={options.allowAdding}
            types={options.types}
            readOnly={options.readOnly}
            hideSelectAllAndClear={options.hideSelectAllAndClear}
            hideSearchField={options.hideSearchField}
            defaultSearchString={options.defaultSearchString}
            theme={options.theme}
            glob={props.glob}
            getValues={options.getValues}
            getDisplayValue={options.getDisplayValue}
            updateStateHook={options.updateStateHook}
            onChange={options.onChange}
            onClose={handleOnClose}
            onContainerClick={handleOnContainerClick}
        />
    );
}
